<ng-container *ngIf="companyStoreService.map$ | async as companies">
  <ng-container *ngIf="companies[companyId!] as company">
    <button type="button" class="btn ellipsis" [matMenuTriggerFor]="singleSelectMenu">({{ company.name }})</button>

    <mat-menu #singleSelectMenu="matMenu" class="company-info">
      <ng-template matMenuContent="">
        <div class="info">
          <h3 class="name">{{ company.name }}</h3>
          <div class="size">
            Size: {{ company.size || 'N/A' }}, Value: {{ company.importance ? '$' + company.importance : 'N/A' }}
          </div>
        </div>
      </ng-template>
    </mat-menu>
  </ng-container>
</ng-container>
